import type { ComponentType } from 'react';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { CommentRepliesComponentProps as RepliesProps } from './index.tsx';

export const LazyRepliesListAsync = lazyForPaint<ComponentType<RepliesProps>>(
	() => import(/* webpackChunkName: "async-reply-comments-list" */ './index'),
);

export default LazyRepliesListAsync;
